/** @format */
import { RegionStateType } from 'src/store/globalDataSlice'

export const eventListToOptions = (data): EventOptions[] | false => {
  if (!data?.length) {
    return []
  }
  const result = []
  data.forEach(
    (
      { productType, productName, eventType, eventTypeDesc, name, nameDesc, iamProjectFlag },
      index
    ) => {
      // 查找productType
      const findProduct = result?.findIndex(({ value }) => productType === value)
      if (findProduct >= 0) {
        // 查找eventType
        const findType = result[findProduct].children.findIndex(({ value }) => eventType === value)
        if (findType >= 0) {
          // 查找name
          const findName = result[findProduct].children[findType].children.findIndex(
            ({ value }) => name === value
          )
          // name没查到
          findName < 0 &&
            result[findProduct].children[findType].children.push({ label: nameDesc, value: name })
        } else {
          // eventType没查到
          result[findProduct].children.push({
            label: eventTypeDesc,
            value: eventType,
            children: [
              {
                label: nameDesc,
                value: name
              }
            ]
          })
        }
      } else {
        // productType没查到
        result.push({
          label: productName,
          value: productType,
          iamProjectFlag,
          children: [
            {
              label: eventTypeDesc,
              value: eventType,
              children: [
                {
                  label: nameDesc,
                  value: name
                }
              ]
            }
          ]
        })
      }
    }
  )
  return result
}

// 产品类型-事件类型-事件名称 筛选
export interface IFilterValues {
  NamespaceId: string
  EventType: string
  Name: string
}
// 产品类型-事件类型-事件名称 option
export interface EventOptions {
  label: string
  value: string | number
  children?: any[]
  iamProjectFlag?: number
}
// context
export interface IContextType {
  date?: { start: number; end: number }
  eventList?: any[]
  eventOptions?: EventOptions[]
  filterValues?: IFilterValues
  setFilterValue?: (value: IFilterValues) => void
  query?: string
  setQuery?: (value: string) => void
  regionList?: RegionStateType['list']
}
